/**
 * @summary 使用DepLink跳转App
 * @param {String} deepLink
 */
export default function handleDeepLink(deepLink: string) {
	if (typeof window === "undefined") return;
	window.location.href = deepLink;
}
